export const sortDropdownDates = (data: any) => {
  data.sort(function (a: { value: string }, b: { value: string }) {
    let keyA = new Date(a.value),
      keyB = new Date(b.value);
    if (keyA < keyB) return 1;
    if (keyA > keyB) return -1;
    return 0;
  });
  return data;
};
